import React, { useMemo } from 'react';
import { useCombinedRefs, InternalProvider } from '../../util';
import { CardIcon } from './elements';
export const PaymentBadge = /*#__PURE__*/React.forwardRef(({
  badgeType,
  disabled,
  height,
  width,
  altText
}, fRef) => {
  const assetUrl = useMemo(() => `https://assets.asurion-ui.my.asurion53.com/images/badges/payment/${badgeType}.svg`, [badgeType]);
  const innerRef = React.useRef();
  const combinedRef = useCombinedRefs(fRef, innerRef);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(CardIcon, {
    "data-aui": "payment-badge",
    ref: combinedRef,
    height: height,
    width: width,
    className: `${disabled ? 'is-disabled' : ''}`,
    src: assetUrl,
    alt: altText === 'placeholder' ? 'Payment Badge Icon' : `${altText} Card`
  }));
});
PaymentBadge.defaultProps = {
  badgeType: 'generic'
};